import { Dialog, Transition } from '@headlessui/react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment, useState } from 'react';

type SideOverlayProps = {
  btnElement: (onClick: () => void) => JSX.Element;
  children: React.ReactNode,
  children2?: React.ReactNode,
  title?: string,
}

const SideOverlay: React.FC<SideOverlayProps> = ({ btnElement, title, children, children2 }) => {

  const [open, setOpen] = useState<boolean>(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return <>

    {btnElement(handleOpen)}
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" style={{ zIndex: 1050 }} className="tw-fixed tw-inset-0 tw-overflow-hidden" onClose={setOpen}>
        <div className="tw-absolute tw-inset-0 tw-overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="tw-ease-in-out tw-duration-500"
            enterFrom="tw-opacity-0"
            enterTo="tw-opacity-100"
            leave="tw-ease-in-out tw-duration-500"
            leaveFrom="tw-opacity-100"
            leaveTo="tw-opacity-0"
          >
            <Dialog.Overlay className="tw-absolute tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75 tw-transition-opacity" />
          </Transition.Child>
          <div className="tw-pointer-events-none tw-fixed tw-inset-y-0 tw-right-0 tw-flex tw-max-w-full tw-pl-10">
            <Transition.Child
              as={Fragment}
              enter="tw-transform tw-transition tw-ease-in-out tw-duration-500 sm:tw-duration-700"
              enterFrom="tw-translate-x-full"
              enterTo="tw-translate-x-0"
              leave="tw-transform tw-transition tw-ease-in-out tw-duration-500 sm:tw-duration-700"
              leaveFrom="tw-translate-x-0"
              leaveTo="tw-translate-x-full"
            >
              <div className="tw-pointer-events-auto tw-w-screen tw-max-w-md">
                <div className="tw-flex tw-h-full tw-flex-col tw-bg-white tw-shadow-xl">
                  <div className="tw-flex-1 tw-overflow-y-auto tw-pt-4 tw-px-4">
                    <div className="tw-flex tw-items-start tw-justify-between">
                      <Dialog.Title className="tw-text-lg tw-font-medium tw-text-gray-900"> {title}</Dialog.Title>
                      <div className="tw-ml-3 tw-flex tw-h-7 tw-items-center">
                        <button
                          title="Fermer"
                          type="button"
                          className="tw--m-2 tw-p-2 tw-text-gray-400 hover:tw-text-gray-500"
                          onClick={handleClose}
                        >
                          <span className="tw-sr-only">Fermer</span>
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </div>
                    </div>
                    <div className="tw-my-6">
                      <div className="tw-flow-root">
                        {children}
                      </div>
                    </div>
                  </div>
                  {
                    children2 && <div className="tw-border-t tw-border-gray-200 tw-py-4 tw-px-4">
                      {children2}
                    </div>
                  }
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>

  </>
}

export default SideOverlay;